import React, {useEffect, useState} from "react";

import {Alert, Breadcrumb, Button, Col, Row} from "react-bootstrap";
import AuthService from "../../services/auth.service";
import Container from "react-bootstrap/Container";
import VenuesService from "../../services/venues.service";
import VenueItem from "../venues/venueItem.component";
import {isLoggedIn} from "../../common/utils";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";

const MyVenuesList = () => {
    const [venues, setVenues] = useState([])

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    const fetchVenues = (user_id) => {
        VenuesService.getVenuesByCreator(user_id).then(
            response => {
                setVenues(response.data.data);
                console.log("my venues:" + JSON.stringify(response.data.data));
            },
            error => {
                console.log(error);
            });
    }

    // load once on mount to fetch all acts
    useEffect(() => {
        let user = AuthService.getCurrentUser();
        fetchVenues(user.id);
    }, []);

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h3>
                        <Breadcrumb>
                            <Breadcrumb.Item active>My Venues</Breadcrumb.Item>
                        </Breadcrumb>
                    </h3>
                </Col>
                <Col>
                    <div className="float-end">
                        {(user !== null && (user.is_host || user.is_admin)) &&
                            <Button href="/venues/new" disabled={!editsAllowed}>New Venue</Button>
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Alert>
                        <div>
                            These are the venues you've created.
                        </div>
                    </Alert>

                    {venues.length === 0 &&
                        <div>You have not created any venues yet. Use the New Venue button to create a venue.</div>
                    }
                    {venues.length > 0 &&
                        venues.map((venue) =>
                            <VenueItem key={venue.id} venue={venue} />
                        )
                    }
                </Col>
            </Row>
        </Container>
    );
};

export default MyVenuesList;
